/* eslint-disable array-callback-return */
/**
 * ActiveFacet template
 * ------------------------------------------------------------------------------
 * Returns an HTML string for an active facet using the given params.
 *
 * @param {Object} params - The parameters for rendering the active facet.
 */

function ActiveFacet (params) {
  if (!params) {
    return ''
  }

  const props = {
    field: params.field || '',
    values: params.value || [],
    range: params.range || null,
  }

  const closeIcon = `
    <svg
      class="clc-ProductGridFacets_ActiveLinkIcon"
      aria-hidden="true"
      focusable="false"
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8.48627 9.32917L2.82849 3.67098" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
      <path d="M2.88539 9.38504L8.42932 3.61524" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>
  `

  const renderPriceValue = rawValue => {
    const parts = rawValue.split('~')
    if (parts.length === 2) {
      const min = parseFloat(parts[0])
      const max = parseFloat(parts[1])
      const formatted = `${window.BAOv2.utils.formatMoney(
        min * 100,
        window.theme.moneyFormat,
      )} - ${window.BAOv2.utils.formatMoney(max * 100, window.theme.moneyFormat)}`
      return formatted
    }
    return rawValue
  }

  return `
    ${props.values
      .map(value => {
        const label = props.field === 'price' ? renderPriceValue(value) : value
        return `
          <facet-remove
            class="clc-ProductGridFacets_ActiveFacet"
            data-filter-label="${props.field}"
            data-filter-value="${value}"
            data-context="nosto"
          >
            <button class="clc-ProductGridFacets_ActiveLink" type="button" data-facet-remove-el="link">
              ${closeIcon}
              ${label}
            </button>
          </facet-remove>
        `
      })
      .join('')}
  `
}

window.theme.results.templates.ActiveFacet = ActiveFacet
